module.exports = __webpack_public_path__ + "img/pr-6.069d523f.png";